<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn depressed small color="primary" class="mt-1" tile v-on="on">
        Book Now
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="title">Enter Order Details</v-card-title>
      <v-card-text class="mt-2">
        <v-form ref="form" v-model="isValid">
          <v-text-field
            dense
            class="mb-2"
            v-model="form.Qty"
            :rules="rules.field"
            outlined
            label="Qty"
            type="number"
          ></v-text-field>
          <v-text-field
            class="mb-2"
            :rules="rules.field"
            v-model="form.Customer_Name"
            dense
            outlined
            label="Name"
            type="text"
          ></v-text-field>
          <v-text-field
            class="mb-2"
            v-model="form.Customer_MobileNo"
            :rules="rules.phone"
            dense
            outlined
            label="Mobile"
            type="text"
          ></v-text-field>
          <v-text-field
            class="mb-2"
            v-model="form.address"
            :rules="rules.field"
            dense
            outlined
            label="Address"
            type="text"
          ></v-text-field>
          <v-text-field
            class="mb-2"
            v-model="form.PinCode"
            outlined
            :rules="rules.field"
            dense
            label="Pin code"
            type="text"
          ></v-text-field>

          <v-textarea
            v-model="form.Remark"
            outlined
            :rules="rules.field"
            hide-details
            no-resize
            label="Remark"
          ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="dialog = false">Cancel</v-btn>
        <v-btn color="green" text @click="orderNow()">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { FIELD, PHONE } from "../../assets/js/rules";
import shoppingService from "../../assets/services/shopping.service";
export default {
  props: {
    id: String,
  },
  data() {
    return {
      rules: {
        field: FIELD,
        phone: PHONE,
      },
      dialog: false,
      form: {},
      isValid: false,
    };
  },
  methods: {
    async orderNow() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let { form } = vm;
      let doc = {
        ItemId: vm.id,
      };
      Object.keys(form).forEach((key) => {
        doc[key] = form[key];
      });
      try {
        vm.$loader.show();
        let { data } = await shoppingService.order(doc);
        if (data.status == "true") {
          vm.$alert.show("Order placed successfully");
          vm.$refs.form.reset();
          vm.dialog = false;
        } else {
          vm.$alert.show(data.message);
        }
        vm.$loader.hide();
      } catch (error) {
        vm.$alert.show(error.message);
        vm.$loader.hide();
      }
    },
  },
};
</script>

<style>
</style>